// modules/recorder.js
import { splitAudioAtTime, generateSplitNames } from './audio-utils.js';
import { visualize } from './visualizer.js';

export function formatTime(ms) {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

export function startCountdown(recordButton, buttonsToDisable = []) {
  return new Promise(resolve => {
    buttonsToDisable.forEach(btn => (btn.disabled = true));
    recordButton.disabled = true;

    let count = 3;
    const countdownEl = document.createElement('div');
    countdownEl.className = 'countdown';
    document.body.appendChild(countdownEl);

    const countInterval = setInterval(() => {
      if (count > 0) {
        countdownEl.textContent = count;
        count--;
      } else {
        clearInterval(countInterval);
        countdownEl.remove();
        resolve();
      }
    }, 1000);
    countdownEl.textContent = count;
  });
}

export function startRecordingTimer(timerDisplay) {
  let startTime = Date.now();
  timerDisplay.style.display = 'block';
  timerDisplay.textContent = '0:00';

  const timerInterval = setInterval(() => {
    const currentTime = Date.now();
    const elapsed = currentTime - startTime;
    timerDisplay.textContent = formatTime(elapsed);
  }, 1000);

  return timerInterval;
}

export function stopRecordingTimer(timerDisplay, timerInterval) {
  clearInterval(timerInterval);
  timerDisplay.style.display = 'none';
}

export function setupRecorder({
  recordButton,
  stopButton,
  soundClips,
  timerDisplay,
  isProMode,
  createAudioClip,
  // Textes personnalisables — valeurs françaises par défaut
  promptClipName = () => prompt('Nom du clip ?', 'sansNom'),
  alertNoMic    = () => alert('getUserMedia n\'est pas supporté par votre navigateur.'),
}) {
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    alertNoMic();   // ← utilise la fonction passée en paramètre
    return;
  }

  const constraints = { audio: true };
  navigator.mediaDevices.getUserMedia(constraints).then(stream => {
    const canvas = document.querySelector('.visualizer');
    visualize(stream, canvas);
    if (window.visualize) {
      visualize(stream);
    }
    const mimeType = MediaRecorder.isTypeSupported('audio/ogg; codecs=opus')
      ? 'audio/ogg; codecs=opus'
      : 'audio/webm';
    const mediaRecorder = new MediaRecorder(stream, { mimeType });
    let chunks = [];
    let timerInterval = null;

    recordButton.onclick = async () => {
      await startCountdown(recordButton, [stopButton]);
      mediaRecorder.start();
      recordButton.classList.add('recording');
      stopButton.disabled = false;

      const importButton = document.querySelector('.import-button');
      const normalizeButton = document.querySelector('.normalize');
      const combineButton = document.querySelector('.combine');

      if (importButton) importButton.disabled = true;
      if (normalizeButton) normalizeButton.disabled = true;
      if (combineButton) combineButton.disabled = true;

      timerInterval = startRecordingTimer(timerDisplay);
    };

    stopButton.onclick = () => {
      mediaRecorder.stop();
      stopRecordingTimer(timerDisplay, timerInterval);
      stopButton.disabled = true;
      recordButton.disabled = false;
      recordButton.classList.remove('recording');

      const importButton = document.querySelector('.import-button');
      const normalizeButton = document.querySelector('.normalize');
      const combineButton = document.querySelector('.combine');

      if (importButton) importButton.disabled = false;
      if (normalizeButton) normalizeButton.disabled = false;
      if (combineButton) combineButton.disabled = false;
    };

    mediaRecorder.ondataavailable = e => chunks.push(e.data);

    mediaRecorder.onstop = () => {
      const blob = new Blob(chunks, { type: mimeType });
      chunks = [];

      const clipName = promptClipName();   // ← utilise la fonction passée en paramètre
      createAudioClip(blob, `${clipName}.mp3`);
    };
  });
}